// import { useCallback } from 'react';

// /**
//  * Custom hook to trigger a print dialog for a specific component reference.
//  */
// const usePrint = (ref, title = document.title) => {
    
//     const handlePrint = useCallback(() => {
//         if (ref.current) {
//             // Store the current DOM state
//             const originalContents = document.body.innerHTML;
//             const printContent = ref.current.innerHTML;
//             const originalTitle = document.title;
            
//             // Temporarily set the document content to only the content to print
//             document.body.innerHTML = printContent;
//             document.title = title;

//             // Trigger print
//             window.print();
            
//             // Restore original DOM state after print dialogue is initiated
//             // setTimeout with 0 is a common workaround to ensure restoration happens 
//             // after the print process has started, though modern browsers handle this better.
//             // setTimeout(() => {
//             //     document.body.innerHTML = originalContents;
//             //     document.title = originalTitle;
//             //     // Force a reload to ensure React correctly re-hydrates the UI
//             //     window.location.reload(); 
//             // }, 0); 
//         }
//     }, [ref, title]);

//     return handlePrint;
// };

// export default usePrint;


import { useCallback } from 'react';

/**
 * Custom hook to open print content in a new tab.
 */
const usePrint = (ref, title = 'Shipping Label') => {
    
    const handlePrint = useCallback(() => {
        if (ref && ref.current) {
            const printContent = ref.current.innerHTML;
            
            // 1. Open a new window/tab
            const printWindow = window.open('', '_blank', 'width=800,height=600');

            // 2. Write the HTML structure
            printWindow.document.write(`
                <html>
                    <head>
                        <title>${title}</title>
                        ${Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
                            .map(style => style.outerHTML)
                            .join('')}
                    </head>
                    <body>
                        ${printContent}
                        <script>
                            // Wait for images and styles to load, then print and close
                            window.onload = () => {
                                window.print();
                                // Optional: Automatically close the tab after printing
                                // window.close(); 
                            };
                        </script>
                    </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();
        }
    }, [ref, title]);

    return handlePrint;
};

export default usePrint;